import React from 'react'

function SuspenseFallback() {
  return (
    <div id="suspense-fallback"></div>
  )
}

export default SuspenseFallback
